import { Flex, Paragraph, ParagraphProps } from 'theme-ui';

export interface ErrorMessageProps extends ParagraphProps {
  padding?: number | string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ padding, sx, ...props }) => (
  <Flex sx={{ justifyContent: 'center', alignItems: 'center', p: padding }}>
    <Paragraph sx={{ color: 'systemWarning', ...sx }} {...props} />
  </Flex>
);

ErrorMessage.defaultProps = {
  padding: 'm'
};

export default ErrorMessage;
